<template>
    <div class="paywall-switcher" :class="theme">
        <p>{{ label }}</p>
        <Toggle :modelValue="toggleVal" @update:modelValue="handleSwitch" />
    </div>
</template>

<style lang="scss" scoped>
.paywall-switcher {
    &.light {
        --bg-color: linear-gradient(270deg, rgba(255, 79, 121, 0.2) -8.75%, rgba(150, 113, 255, 0.2) 78.31%, rgba(125, 139, 247, 0.2) 109.21%);
        --text-color: #323653;
        --toggle-bg-color: rgba(236, 85, 146, 0.2);
        --toggle-bg-active-color: #828AF7;
    }

    &.dark {
        --bg-color: linear-gradient(270deg, rgba(255, 79, 121, 0.2) -8.75%, rgba(150, 113, 255, 0.2) 78.31%, rgba(125, 139, 247, 0.2) 109.21%);
        --text-color: #FFFFFF;
        --toggle-bg-color: rgba(236, 85, 146, 0.2);
        --toggle-bg-active-color: #828AF7;
    }

    &.yellow {
        --bg-color: rgba(218, 163, 101, 0.2);
        --text-color: #323653;
        --toggle-bg-color: rgba(0, 0, 0, 0.25);
        --toggle-bg-active-color: #DAA365;
    }

    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--bg-color);
    border-radius: 25px;
    height: 54px;
    width: 100%;
    padding: 1rem;

    p {
        color: var(--text-color)
    }

    :deep(.simple-toggle) {
        background-color: var(--toggle-bg-color);

        &.active {
            background-color: var(--toggle-bg-active-color);
        }
    }
}
</style>

<script>
import Toggle from '@/components/Toggle.vue';
import { ref } from 'vue';

export default{ 
    components: {
        Toggle
    },
    props: {
        label: {
            type: String,
            default: ''
        },
        theme: {
            type: String,
            validator: (value) => ['light', 'dark', 'yellow'].includes(value),
            default: 'light'
        },
        modelValue: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const toggleVal = ref(props.modelValue)
        return {
            toggleVal,
            handleSwitch: (value) => {
                toggleVal.value = value
                emit('update:modelValue', toggleVal.value)
            }
        }
    }
}
</script>
